export default __webpack_public_path__ + "static/media/06_photo.4c151e23.jpg";